import { z } from 'zod';
// OppositionType is a const object, use z.enum for its values
export const createOppositionSchema = z.object({
    name: z.string().min(2, 'El nombre debe tener al menos 2 caracteres').max(200),
    type: z.enum(['policia_local', 'policia_nacional', 'bomberos'], {
        message: 'Tipo de oposición inválido',
    }),
    is_enabled: z.boolean().default(true),
    description: z.string().max(1000).optional(),
});
export const updateOppositionSchema = createOppositionSchema.partial();
//# sourceMappingURL=opposition.schema.js.map